import React, { createContext, useState } from 'react'
import AssessmentLibrary from './AssessmentLibrary'
import { AssessmentDefDrawer } from 'pages/School/AssessmentDef'

const AssessmentLibraryPage = () => {
    const [currentAssessmentDef, setCurrentAssessmentDef] = useState(null)
    const [openAssesmentDefDrawer, setOpenAssesmentDefDrawer] = useState(false)

    const commonValue = {
        currentAssessmentDef, setCurrentAssessmentDef,
        openAssesmentDefDrawer, setOpenAssesmentDefDrawer
    }

    return (
        <AssessmentLibraryContext.Provider value={commonValue}>
            <AssessmentLibrary />
            <AssessmentDefDrawer
                open={openAssesmentDefDrawer}
                handleDrawer={setOpenAssesmentDefDrawer}
                assessmentDefId={currentAssessmentDef?.id}
                categoryName={currentAssessmentDef?.categoryName}
            />
        </AssessmentLibraryContext.Provider>
    )
}
export const AssessmentLibraryContext = createContext()
export default AssessmentLibraryPage